import React from "react";
import Table from "../common/table";

const RptDetailsTable = ({ id, columns, data, onSort, sortColumn }) => {
  return (
    <Table
      id={id}
      columns={columns}
      data={data}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default RptDetailsTable;
